var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24984 5.83399H5.83317C3.53198 5.83399 1.6665 7.69947 1.6665 10.0007C1.6665 12.3018 3.53198 14.1673 5.83317 14.1673H7.49984C9.80102 14.1673 11.6665 12.3018 11.6665 10.0007M13.7498 14.1673H14.1665C16.4677 14.1673 18.3332 12.3018 18.3332 10.0007C18.3332 7.69947 16.4677 5.83398 14.1665 5.83398H12.4998C10.1987 5.83398 8.33317 7.69947 8.33317 10.0007",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.59442838ae057ab8f65434248fbc7108.svg";
export { ForwardRef as ReactComponent };